import script from "./InstitutionPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./InstitutionPreview.vue?vue&type=script&lang=ts&setup=true"

export default script